module.exports = __webpack_public_path__ + "img/immune2.f3ff21c5.png";